

























































import {
  Vue, Prop, Component,
} from 'vue-property-decorator';
import MainButton from '@/shared/buttons/main-button.component.vue';

@Component({
  components: {
    MainButton,
  },
})
export default class BillingModalPushOrderRequest extends Vue {
  @Prop({
    required: true,
  })
  showModal!: boolean;

  @Prop()
  pushOrderPendence!: number;

  closeModal() {
    this.$emit('closeModal', true)
  }

  execute() {
    this.$emit('execute');
    this.$emit('closeModal', false);
  }

  goToContractView() {
    window.open(`${window.location.origin}/contracts?status=PUSH_ORDER_REQUIRED_BUT_ABSENT`, '_blank');
  }
}
